import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const PopupFooter = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="layer_foot">
      {children}
    </div>
  );
});

PopupFooter.displayName = 'PopupFooter';

export default PopupFooter;
